import { IconActionPlus24 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { ControlButton } from '../ControlButton';

import styles from './ZoomIn.css';

type ZoomInProps = {
  handleClick: VoidFunction;
};

export const ZoomIn: FC<ZoomInProps> = props => {
  const { handleClick } = props;

  return (
    <ControlButton
      className={styles['button']}
      handleClick={handleClick}
      icon={<IconActionPlus24 color="icon-primary-default" />}
      testId="map-controls.zoom-in"
    />
  );
};
